import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import _has from 'lodash/has';
import { Locks, LocksAttributes } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';

// 判断是否有锁定纵横比属性
export function hasLockAspect(locks) {
    return locks && _has(locks, LocksAttributes.NO_CHANGE_ASPECT);
}

// 获取锁定纵横比属性值
export function getLockAspect(props, locksStr: string, defaultValue?: number): number {
    const locks = props[locksStr];
    return hasLockAspect(locks) ? locks.noChangeAspect : defaultValue;
}

export default function isLockAspect(type: string, props): number | undefined {
    const { SHAPE, GROUP, IMAGE } = UIModelType;
    if ([SHAPE, GROUP, IMAGE].includes(type as UIModelType)) {
        // eslint-disable-next-line no-restricted-syntax
        for (const lockType of [
            Locks.LOCKS,
            // @hotfix 兼容老的属性名
            Locks.GRP_LOCKS,
            Locks.PIC_LOCKS,
            Locks.SP_LOCKS,
        ]) {
            const lockAspect = getLockAspect(props, lockType);
            if (lockAspect !== undefined) {
                return lockAspect;
            }
        }
    }
}
